/**
 * Created by Sergii on 02.10.2018.
 */
import { connect } from 'react-redux';
import * as actions from '../actions/index';
import {MessageBox} from "@common/components/MessageBox.jsx";
import {I18n} from 'react-redux-i18n';

const mapStateToProps = state => {
    return {
        type: state.messageBox.type,
        header: I18n.t(state.messageBox.header),
        text: I18n.t(state.messageBox.text) ? I18n.t(state.messageBox.text) : state.messageBox.text,
        show: state.messageBox.show,
        confirmText: state.messageBox.confirmText ? I18n.t(state.messageBox.confirmText) : undefined,
        cancelText: state.messageBox.cancelText ? I18n.t(state.messageBox.cancelText) : undefined,
        size: state.messageBox.size
    }
};

const mapDispatchToProps = dispatch => {
    return {
        hideMessageBox: () => dispatch(actions.showMessageBox(false)),
        onCustomOk: (type) => dispatch(actions.messageBoxConfirmed(type))
    }
};

const TestResultsMessageBoxController = connect(
    mapStateToProps,
    mapDispatchToProps
)(MessageBox);

export default TestResultsMessageBoxController;
